import PropTypes from "prop-types";
import React from "react";
import Radio from "app/pages/.shared/form/Radio.jsx";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import { FormattedMessage } from "react-intl";

class BookingRentalAccommodation extends React.Component {
	constructor() {
		super();
		this.onChange = this.onChange.bind(this);
	}

	onChange() {
		this.props.onChange(this.props.rentalAccommodation);
	}

	render() {
		const { rentalAccommodation, field, id, ...props } = this.props;

		return (
			<Radio
				field={field}
				id={id}
				value={rentalAccommodation.accommodation}
				toggle={this.onChange}
				checked={field.value === rentalAccommodation.accommodation}
				data-cy={props["data-cy"]}
			>
				<div className="rental-accommodations__content">
					<div className="rental-accommodations__label">
						{rentalAccommodation.accommodation}
					</div>
					<div className="rental-accommodations__price">
						<div className="rental-accommodations__price--final">
							<AmountContainer
								amount={rentalAccommodation.minPrice.p}
								prefix={<FormattedMessage id="offer.per.person.from.label" />}
								suffix={
									<FormattedMessage id="general.amount.per.accommodation.suffix.label.short" />
								}
							/>
						</div>
						{rentalAccommodation.minPrice.pp ? (
							<div className="rental-accommodations__price--public">
								<AmountContainer
									amount={rentalAccommodation.minPrice.pp}
									suffix={
										<FormattedMessage id="general.amount.per.accommodation.suffix.label.short" />
									}
								/>
							</div>
						) : (
							false
						)}
					</div>
				</div>
			</Radio>
		);
	}
}

BookingRentalAccommodation.defaultProps = {
	rentalAccommodation: {},
	field: {},
};

BookingRentalAccommodation.propTypes = {
	id: PropTypes.string,
	rentalAccommodation: PropTypes.object,
	field: PropTypes.object,
	onChange: PropTypes.func,
};

export default BookingRentalAccommodation;
